import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
export const useFilterOptions = ownSource => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  return useMemo(() => {
    return [!ownSource && {
      label: t('amadeusRatingSection.filters.options.all'),
      value: 'all'
    }, {
      label: t('amadeusRatingSection.filters.options.family'),
      value: 'family'
    }, {
      label: t('amadeusRatingSection.filters.options.single'),
      value: 'single'
    }, {
      label: t('amadeusRatingSection.filters.options.couple'),
      value: 'couple'
    }, {
      label: t('amadeusRatingSection.filters.options.friends'),
      value: 'friends'
    }, ownSource && {
      label: t('amadeusRatingSection.filters.options.withRecommendation'),
      value: 'withRecommendation'
    }, ownSource && {
      label: t('amadeusRatingSection.filters.options.withoutRecommendation'),
      value: 'withoutRecommendation'
    }, ownSource && {
      label: t('amadeusRatingSection.filters.options.withText'),
      value: 'withText'
    }, ownSource && {
      label: t('amadeusRatingSection.filters.options.withPhotos'),
      value: 'withPhotos'
    }].filter(option => option !== false);
  }, [t, ownSource]);
};